module.exports = __webpack_public_path__ + "img/1-3.532c6e95.png";